import {ROUTES} from '../../config/index.js'

export const getInitialProps = async ({
  routeInfo,
  context: {
    i18n: {culture},
    domain
  }
}) => {
  const config = domain.get('config')
  const {DEFAULT_SEARCH: defaultSearch} = config.get('dealer')
  const provinces = config.get('provinces')
  const {DEALERS_LIST_PATH} = config.get('page')

  const {
    location: {
      pathname: path,
      search: searchFromUrl,
      query: {or = defaultSearch.sortOrder, fi = defaultSearch.sortBy, pg = defaultSearch.page, ...restQuery}
    }
  } = routeInfo

  const route = `${path}${searchFromUrl}`

  const {pageName} = await domain.get('get_page_name_page_use_case').execute({path: route})

  const _getSearchData = () => domain.get('get_search_data_from_url_search_use_case').execute({path, url: path})

  const [searchDataError, searchData] = await _getSearchData()

  const {search: {filters: {vehicles = [], provinceIds = [], city, cityId}} = {}} = searchData || {}

  const [{makeId, make} = {}] = vehicles
  const [provinceId] = provinceIds

  const province = provinces.find(province => province.id === provinceId)?.label

  const initialQuery = {or, fi, pg, MakeId: makeId, provinceId, province, make, cityId, ...restQuery}

  const _getDealers = ({searchQuery}) => {
    return domain.get('get_search_results_dealer_use_case').execute({pageName, searchQuery})
  }

  const [initialResultsError, initialResultsResponse = {}] =
    provinceId || makeId ? await _getDealers({searchQuery: initialQuery}) : []

  if (initialResultsError || searchDataError) {
    return {__HTTP__: {redirectTo: ROUTES.DEALERS_LIST.INDEX}}
  }

  const {search, totalPages, totalResults} = initialResultsResponse

  const _getPagination = () =>
    domain.get('get_pagination_search_url_dealer_use_case').execute({
      pageName,
      search,
      path,
      queryPlaceholder: {
        query: 'pg',
        placeholder: '%{pageNumber}'
      }
    })

  const _getSeoData = () =>
    domain.get('get_seo_data_use_case').execute({
      culture,
      pageName,
      params: {
        city,
        make,
        province,
        totalPages, // TODO: check if this is used
        nResults: totalResults,
        path
      }
    })

  const _getMakes = () => domain.get('get_marketed_makes_vehicles_use_case').execute({urlPrefix: DEALERS_LIST_PATH})

  const _getProvinceTagClouds = () =>
    domain.get('get_tagcloud_seo_use_case').execute({
      context: 'dealersProvinces',
      makeId,
      provinceId,
      pageName
    })

  const _getCityTagClouds = () =>
    provinceId
      ? domain.get('get_tagcloud_seo_use_case').execute({
          context: 'dealersCities',
          makeId,
          provinceId,
          pageName
        })
      : Promise.resolve([])

  const _getMakeTagClouds = () =>
    domain.get('get_tagcloud_seo_use_case').execute({
      context: 'dealersMakes',
      makeId,
      provinceId,
      pageName
    })

  const [
    {
      value: [paginationSearchUrlError, {url}]
    },
    {
      value: [seoDataError, seoDataResponse]
    },
    {value: provinceTagclouds = []},
    {value: cityTagclouds = []},
    {value: makeTagclouds = []},
    {value: makesResponse}
  ] = await Promise.allSettled([
    _getPagination(),
    _getSeoData(),
    _getProvinceTagClouds(),
    _getCityTagClouds(),
    _getMakeTagClouds(),
    _getMakes()
  ])

  const {head: helmet = {}, h1} = seoDataResponse || {}

  const mergedTagclouds = [...provinceTagclouds, ...cityTagclouds, ...makeTagclouds]

  const {makesList} = makesResponse || {}

  const searchFilters = searchDataError ? {} : searchData.search.filters

  return {
    city,
    h1,
    helmet,
    initialResultsResponse,
    pageName,
    paginationUrl: url,
    pageErrors: {
      initialResultsError,
      paginationSearchUrlError,
      searchDataError,
      seoDataError
    },
    province,
    make,
    makesList,
    searchFilters,
    tagclouds: mergedTagclouds
  }
}
